import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, UntypedFormControl, ValidatorFn, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { MdbSwitchComponent } from 'app/core/components/mdb-switch/mdb-switch.component';
import { CoreModule } from 'app/core/core.module';
import { loadManageCampaignList, putCampaign, putCampaignByProperties } from '../../../campaign/features/campaign.actions'
import { MdbpInputComponent } from 'app/core/components/mdb-input/mdb-input.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbValidationModule } from 'mdb-angular-ui-kit/validation';
import { NgxCurrencyDirective } from 'ngx-currency';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import  _  from 'lodash'
import { selectCampaignList, selectDonationCampaignList, selectUpdatedTicketingCampaign } from 'app/campaign/features/campaign.selectors';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';
import { debounceTime, filter, map } from 'rxjs';
import { AddOnDonationComponent } from 'app/reports/components/modal/add-on-donation/add-on-donation.component';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { CampaignService } from 'app/campaign/services';
import { LoadingService } from 'app/core/services/loading.service';
@Component({
  selector: 'app-ticketing-setings',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    MdbpInputComponent,
    MdbValidationModule,
    MdbFormsModule,
    NgxCurrencyDirective,
    MdbSelectModule,
  ],
  templateUrl: './ticketing-setings.component.html',
  styleUrl: './ticketing-setings.component.scss'
})
export class TicketingSetingsComponent implements OnInit {
  private destroyRef = inject(DestroyRef)
  public campaign: any;
  public typeData: any;
  public settingsForm: FormGroup

  public onClose: Function;
  public soldCount: number = 0
  public isTolalInventoryValid = false;
  public donationCampaigns;

  public latestUpdatedProperty = '';
  public showUpdatedMessage = false;
  private ticketingCampaignUpdated$ = this.store.pipe(
    takeUntilDestroyed(),
    select(selectUpdatedTicketingCampaign)
  )
  constructor(
    private fb: FormBuilder,
    private store: Store,
    private campaignService: CampaignService,
    private loadingService:LoadingService,
  ) {}

  ngOnInit(): void {
    const self = this;
    this.loadingService.enabled = false;

    this.campaignService.getManageCampaignList(_, {statusFilter: 0, campaignTypes: [CAMPAIGN_TYPE.DONATE]})
      .subscribe(campaings => {
        this.loadingService.enabled = true;
        this.donationCampaigns = campaings;
      })
    
    this.typeData = this.campaign.campaignTypeData;
    const { presetOptions } = this.typeData;
    presetOptions
      .filter((opt)=>!opt.status)
      .forEach(option => {
        if(!option.dontCountForGlobalInventory) {
          this.soldCount += option.bookedCount
        }
      })

    function requiredIfEnforced(enforceControlName: string): ValidatorFn {
      return (control: AbstractControl): { [key: string]: any } | null => {
        const enforceControl = control.parent?.get(enforceControlName);
        if (enforceControl && enforceControl.value === true) {
          return Validators.required(control)
        }
        return null;
      };
    }
    
    function minIfEnforced(enforceControlName: string, minValue: number): ValidatorFn {
      return (control: AbstractControl): { [key: string]: any } | null => {
        const enforceControl = control.parent?.get(enforceControlName);
        if (enforceControl?.value == true) {
          return control.value < minValue ? {'incorrect': true} : null;
        } else {
          return control.value <= 0 ? { 'incorrect': true}: null;
        }

      };
    }

    function addOnDonationValidator(control: AbstractControl): { [key: string]: any } | null {
      const addOnDonationControl = control.parent?.get('addOnDonation');
      const campaignIdControl = control.parent?.get('addOnDonationCampaignId');
      const valueNotChanged = campaignIdControl?.value === self.campaign.id;
      if (addOnDonationControl?.value === true) {
        if(valueNotChanged){
          return {'theSameValue': true}
        } else if(campaignIdControl?.value === ''){
          return {'campaignNotSelected': true}
        }
      }

      return null;
    }

    function enforceInventoryValidator(control: AbstractControl): { [key: string]: any } | null {
      const campaignInventoryControl = control.parent?.get('campaignInventoryCount');
      campaignInventoryControl?.updateValueAndValidity()
      if(control.value === false){
        return null;
      }

      if (campaignInventoryControl && campaignInventoryControl.invalid) {
        return { 'inventoryCountInvalid': true };
      }

      return null;
    }

    function donationCampaignIdValidator(control: AbstractControl): { [key: string]: any } | null {
      const addOnDonationControl = control.parent?.get('addOnDonation');
      const campaignIdControl = control.parent?.get('addOnDonationCampaignId');
      if(addOnDonationControl?.value === true && campaignIdControl?.value === ""){
        return { "campaignNotSelected": true }
      }

      return null;
    }
    
    this.settingsForm = this.fb.group({
      ticketForInPersonEvent: [{ value: this.typeData.isTicketForInPersonEvent, disabled: true }],
      ticketForVirtualEvent: [{ value: this.typeData.isTicketForVirtualEvent, disabled: true }],
      ticketForRaffle: [{ value: this.typeData.isRaffleTicket, disabled: true }],
        ticketForBasketRaffle: [{ value: this.typeData.basketRaffle, disabled: true }],
      
      addOnDonation: [{ value: this.typeData.addOnDonationCampaignId !== '', disabled: false },
        [addOnDonationValidator]
      ],
        addOnDonationCampaignId: [{ value: this.typeData.addOnDonationCampaignId, disabled: false },
          donationCampaignIdValidator
        ],

      electronicTickets: [{ value: this.typeData.sendTickets, disabled: false }],

      enforceInventory: [{ value: this.typeData.enforceCampaignInventory, disabled: false },
        [enforceInventoryValidator]
      ],
        campaignInventoryCount: [{ value: this.typeData.campaignInventory, disabled: false },
          [ minIfEnforced('enforceInventory', this.soldCount), requiredIfEnforced('enforceInventory')] ,
        ],
        hideCampaignInventory: [{ value: this.typeData.hideCampaignInventory, disabled: false }],

      saveCardEnabled: [{ value: this.typeData.saveCardEnabled, disabled: false }],

      checkinEmailNotification: [{ value: this.typeData.sendCheckinEmail, disabled: false }],
        checkinTextNotification: [{ value: this.typeData.sendCheckinText, disabled: false }]
    });

    const campaignInventory = this.settingsForm.get('campaignInventoryCount') as UntypedFormControl;
    campaignInventory.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(value => {
      if(value < this.soldCount){
        campaignInventory.setErrors({'incorrect': true});
        this.isTolalInventoryValid = false;
      } else{
        campaignInventory.setErrors(null);
        this.isTolalInventoryValid = true;
      }
    })

    const enforceInventory = this.settingsForm.get('enforceInventory') as UntypedFormControl;
    enforceInventory.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(value => {
      setTimeout(() => {
        if(!value){
          this.settingsForm.get('hideCampaignInventory').setValue(false, { emitEvent: false })
        }
        
        this.settingsForm.get('campaignInventoryCount').setValue(0, { emitEvent: false })
        this.settingsForm.get('campaignInventoryCount').setErrors(null)
        this.settingsForm.get('campaignInventoryCount').markAsUntouched()
      })
    })

    const checkinEmailControl = this.settingsForm.get('checkinEmailNotification') as UntypedFormControl;
    const checkinTextControl = this.settingsForm.get('checkinTextNotification') as UntypedFormControl;

    checkinEmailControl.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(emailNotificationEnabled => {
      if (!emailNotificationEnabled) {
        setTimeout(() => {
          checkinTextControl.setValue(false, { emitEvent: false, onlySelf: true, });
        })
      }
    });

    const addOnDonationControl = this.settingsForm.get('addOnDonation') as UntypedFormControl;
    const addOnDonationCampaignIdConrol = this.settingsForm.get('addOnDonationCampaignId') as UntypedFormControl
    addOnDonationControl.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((value) => {
        addOnDonationCampaignIdConrol.setValue('')
        addOnDonationCampaignIdConrol.markAsUntouched();
    })
    
    this.subscribeToFormChanges()
    this.ticketingCampaignUpdated$.subscribe((updatedCampaign) => {
      if(updatedCampaign &&! _.isEqual(updatedCampaign, this.campaign)){
        this.showUpdatedMessage = true;
        this.campaign = updatedCampaign;
      } else{
        this.showUpdatedMessage = false;
      }
    })
  }

  private subscribeToFormChanges(): void {
    Object.keys(this.settingsForm.controls).forEach(controlName => {
      this.settingsForm.get(controlName)?.valueChanges.pipe(
        debounceTime(300) 
      ).subscribe(newValue => {
        const control = this.settingsForm.get(controlName);
        control.updateValueAndValidity({ emitEvent: false });
        control.markAsTouched();
        if (control?.invalid) {
          return;
        }

        this.latestUpdatedProperty = controlName;
        this.onUpdateByProperties(controlName, newValue);
      });
    });
  }

  onUpdateByProperties(changedKey: string, changedValue: any){
    let propertyName = changedKey;
    let propertyValue = changedValue;

    switch (changedKey) {
      case 'addOnDonation':
        propertyName = 'addOnDonationCampaignId';
        propertyValue = changedValue ? this.settingsForm.get('addOnDonationCampaignId')?.value || '' : '';
        break;
      case 'hideCampaignInventory':
        propertyName = "hideCampaignInventory"
        break;
      case 'enforceInventory':
      case 'campaignInventoryCount':
        const campaignInventory = this.settingsForm.get('campaignInventoryCount')?.value
        const enforceCampaignInventory = this.settingsForm.get('enforceInventory')?.value

        if (campaignInventory === this.campaign.campaignTypeData.campaignInventory){
          this.showUpdatedMessage = false;
          return;
        }

        propertyName = 'enforceCampaignInventory';
        propertyValue = {
          enforceCampaignInventory: enforceCampaignInventory,
          campaignInventory: campaignInventory || 0,
          hideCampaignInventory: this.settingsForm.get('hideCampaignInventory')?.value
        };
        break;
      case 'checkinEmailNotification':
        propertyName = 'sendCheckinEmail';
        break;
      case 'checkinTextNotification':
        propertyName = 'sendCheckinText';
        break;
      case 'electronicTickets':
        propertyName = 'sendTickets';
        break;
      case 'saveCardEnabled':
        propertyName = 'saveCardEnabled';
        break;
    }
  
    const transformedProps = [{
      propertyName,
      propertyValue
    }];

    this.showUpdatedMessage = false;
    this.store.dispatch({
      type: putCampaignByProperties.type,
      propertiesToUpdate: transformedProps,
      campaignId: this.campaign.id
    });
  }

  getSold(){
    const campaignInventory = this.settingsForm.get('campaignInventoryCount') as UntypedFormControl;
    const hideCampaignInventory = this.settingsForm.get('hideCampaignInventory') as UntypedFormControl;
    
    if (hideCampaignInventory.value) {
      if (this.soldCount){
        return `${this.soldCount} Sold.` 
      }

      return 'None sold yet.'
    } else {
      if (this.soldCount > 0){
        const soldText = campaignInventory.value > 0 ? `of ${campaignInventory.value} sold.` : ' of 0 sold.';
        return `${this.soldCount} ${soldText}`; 
      } 

      const soldText = campaignInventory.value > 0 ? `0 of ${campaignInventory.value} sold.` : 'None sold yet.';
      return `${soldText}`; 
    }
  }

  getCampaignName(campaignId: string): string | undefined {
    const selectedCampaign = this.donationCampaigns.find(campaign => campaign.id === campaignId);
    return selectedCampaign?.name;
  }
}
